import './AuthPage.scss';
import AuthForm from "../../components/layout/AuthForm/AuthForm";
import AuthAction from "../../components/layout/AuthAction/AuthAction";
import {useProfileStore} from "../../store/profile/pofile.store";
import {useNavigate} from "react-router-dom";
import {useEffect} from "react";
import {Sparkles, MessageCircleHeart, AudioLines, Languages} from "lucide-react";

interface AuthPageProps {
    type: 'login' | 'signup' | 'reset' | 'action';
}

const features = [
    {icon: <MessageCircleHeart size={18}/>, text: 'Learns from your real chat history'},
    {icon: <Languages size={18}/>, text: 'Replies in their style, in 20 languages'},
    {icon: <AudioLines size={18}/>, text: 'Voice replies in their own voice'},
];

export default function AuthPage({type}: AuthPageProps) {

    const {user} = useProfileStore()
    const navigate = useNavigate();


    // Signed-in people skip the auth pages, except email links (e.g. verifying while signed in)
    useEffect(() => {
        if (user && type !== 'action') {
            navigate('/')
        }
    }, [user, navigate, type])

    return (
        <div className="AuthPage">
            <aside className="AuthPage__brand">
                <div className="AuthPage__logo">
                    <div className="icon-tile"><Sparkles size={18}/></div>
                    <span>Soulify</span>
                </div>

                <div className="AuthPage__pitch">
                    <h1>Make your old chats talk again</h1>
                    <p>Turn a chat history into an AI that texts like someone you miss.</p>
                    <ul>
                        {features.map((feature) => (
                            <li key={feature.text}>
                                <span className="AuthPage__featureIcon">{feature.icon}</span>
                                {feature.text}
                            </li>
                        ))}
                    </ul>
                </div>

                <span className="AuthPage__footnote">AI simulations, not real people.</span>
            </aside>

            <main className="AuthPage__main">
                {type === 'action' ? <AuthAction/> : <AuthForm type={type}/>}
            </main>
        </div>
    );
}
